// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Component, Input } from '@angular/core';
import { Deal } from '@interfaces/deal.interfaces';

@Component({
    selector: 'app-deal-card',
    templateUrl: './deal-card.component.html',
    styleUrls: ['./deal-card.component.scss'],
})
export class DealCardComponent {
    @Input() deal: Deal;
    @Input() dealUrl: string[];
    @Input() actionName = 'VIEW DEAL';
    @Input() isCustomer = false;
}
